import { ReportBuilderActionTypes } from "./constants";
import {
  renameDuplicate,
  renameFieldDuplicate,
} from "../../utils/renameDuplicate";
import { FindFormIndex } from "../../utils/FindFormIndex";
import { updateFieldById } from "../../utils/updateFieldById";

interface Section {
  height: number;
  elements: any[];
}
type SectionKey = "header" | "detail" | "footer";
interface State {
  currentReportId: any;
  reportId: any | "";
  reportLocationId: any;

  sectionss: {
    header: Section;
    detail: Section;
    footer: Section;
  };

  config?: {
    publicSettings?: any;
    charts?: any[];
  };
}
const INIT_STATE = {
  currentReportId: "",
  reportId: "",
  reportLocationId: "",

  sectionss: {
    header: {
      height: 90,
      elements: [],
    },

    detail: {
      height: 380,
      elements: [],
    },

    footer: {
      height: 70,
      elements: [],
    },
  },

  config: {
    publicSettings: {},
    charts: [],
     selected: null,
  },
};

const ReportBuilder = (state: State = INIT_STATE, action: any): any => {
  // تابع بازگشتی برای برگرداندن index و خود نود

  switch (action.type) {
    // case ReportBuilderActionTypes.CHANGE_RESET_INITIAL_STATE:
    //   return {
    //     ...INIT_STATE,
    //   };

    case ReportBuilderActionTypes.CHANGE_REPORT_LOCATION:
      return {
        ...state,
        reportLocationId: action.payload,
      };

    case ReportBuilderActionTypes.CHANGE_CHARTS:
      

      return {
        ...state,
        config: {...state.config,charts:action.payload},
    
      };


    case ReportBuilderActionTypes.UPDATE_ELEMENT: {
      const { sectionKey, id, updates } = action.payload;
         const section = state.sectionss[
          sectionKey as "header" | "detail" | "footer"
                ];
     

      if (!section) {
        return state;
      }

      return {
        ...state,

        sectionss: {
          ...state.sectionss,

          [sectionKey]: {
            ...section,

            elements: section.elements.map((el:any) => {
              if (el.id !== id) {
                return el;
              }

              const merged = {
                ...el,
                ...updates,
              };

              if (updates.props) {
                merged.props = {
                  ...el.props,
                  ...updates.props,
                };
              }

              return merged;
            }),
          },
        },
      };
    }

    case ReportBuilderActionTypes.ADD_ELEMENT: {
  const { sectionKey, element } = action.payload as {
    sectionKey: SectionKey;
    element: any;
  };

  const section = state.sectionss[sectionKey];

  if (!section) {
    return state;
  }

  return {
    ...state,

    sectionss: {
      ...state.sectionss,

      [sectionKey]: {
        ...section,

        elements: [
          ...section.elements,
          element,
        ],
      },
    },
  };
}


case ReportBuilderActionTypes.UPDATE_SECTION_HEIGHT: {
  const { sectionKey, height } = action.payload as {
    sectionKey: SectionKey;
    height: number;
  };

  const section = state.sectionss[sectionKey];

  if (!section) {
    return state;
  }

  return {
    ...state,

    sectionss: {
      ...state.sectionss,

      [sectionKey]: {
        ...section,
        height,
      },
    },
  };
}


case ReportBuilderActionTypes.DELETE_ELEMENT: {
  const { sectionKey, id } = action.payload as {
    sectionKey: SectionKey;
    id: string;
  };

  const section = state.sectionss[sectionKey];

  if (!section) {
    return state;
  }

  return {
    ...state,

    sectionss: {
      ...state.sectionss,

      [sectionKey]: {
        ...section,

        elements: section.elements.filter(
          (el) => el.id !== id
        ),
      },
    },
  };
}

case ReportBuilderActionTypes.SET_SECTIONS:
  return {
    ...state,
    sectionss: action.payload,
  };
    
  case ReportBuilderActionTypes.SET_SELECTED:
  return {
    ...state,

    config: {
      ...state.config,
      selected: action.payload,
    },
  };
  
  
  // case ReportBuilderActionTypes.CHANGE_HEDER:

    // case ReportBuilderActionTypes.CHANGE_REPORT_PUBLICSETTING:

    default:
      return state;
  }
};

export default ReportBuilder;
